import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { OnboardingStore } from '@boxx/onboarding-core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ContactChartWidgetComponent } from './contact-chart-widget/contact-chart-widget.component';
import { DevicesChartWidgetComponent } from './devices-chart-widget/devices-chart-widget.component';
import { GmbInitialComponent } from './gmb-initial-component/gmb-initial-component';
import { KpiItemComponent } from './kpi-item/kpi-item.component';
import { MainHeaderComponent } from './main-heder/main-header.component';
import { NotificationsComponent } from './notifications-component/notifications-component';
import { PanelWidgetComponent } from './panel-widget/panel-widget.component';
import { QrComponent } from './qr-component/qr-component';
import { QrPopoverComponent } from './qr-component/qr-popover.component';
import { QueriesChartWidgetComponent } from './queries-chart-widget/queries-chart-widget.component';
import { ViewsChartWidgetComponent } from './views-chart-widget/views-chart-widget.component';
import { TotalplayComponent } from './qr-component/totalplay/totalplay.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
  declarations: [
    ContactChartWidgetComponent,
    QueriesChartWidgetComponent,
    DevicesChartWidgetComponent,
    ViewsChartWidgetComponent,
    KpiItemComponent,
    MainHeaderComponent,
    PanelWidgetComponent,
    QrComponent,
    QrPopoverComponent,
    TotalplayComponent,
    GmbInitialComponent,
    NotificationsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    QRCodeModule,
  ],
  exports: [
    ContactChartWidgetComponent,
    QueriesChartWidgetComponent,
    DevicesChartWidgetComponent,
    ViewsChartWidgetComponent,
    KpiItemComponent,
    MainHeaderComponent,
    PanelWidgetComponent,
    QrComponent,
    QrPopoverComponent,
    TotalplayComponent,
    GmbInitialComponent,
    NotificationsComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [OnboardingStore],
})
export class PanelCoreComponentsModule {}
